import api from './api'

const resource = '/ratings/outlets'

export default {
    get(filter) {
        return api.get(`/ratings/regions?filter=${filter}`);
    },
    general() {
        return api.get(`/ratings/general`);
    },
    getRegion(region='', branch='', outlet='', start, end, facility='') {
        if(region!='' && region!=999999){
            if(branch!='' && branch!=999999){
                if(outlet!='' && outlet!=999999){
                    return api.get(`${resource}?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&facility=${facility}`);
                } else {
                    return api.get(`${resource}?region=${region}&branch=${branch}&start=${start}&end=${end}`);
                }
            } else {
                return api.get(`${resource}?region=${region}&start=${start}&end=${end}`);
            }
        } else {
            return api.get(`${resource}?start=${start}&end=${end}`);
        }
        
    },
    getDetail(npp, start, end) {
        return api.get(`/ratings/detail/${npp}?start=${start}&end=${end}`);
    },
    getBranch(id, page, q) {
        return api.get(`/ratings/branch/${id}?page=${page}&q=${q}`);
    },
    getByCategory(region, branch, outlet, start, end) {
        return api.get(`/ratings/category?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}`);
    },
    getTop() {
        return api.get(`/ratings/top`);
    }
}